import { FC, useContext, useState } from 'react';
import styles from './ConfirmAccountPickOwner.module.scss';
import common from '../../util/scss/common.module.scss';
import { Button } from '@mui/material';
import RadioButton from '../RadioButton/RadioButton';
import GlobalContext from '../../contexts/GlobalContext';
import { useHistory } from 'react-router-dom';
import Card from '../Card/Card';
import { ERoutes } from '../../util/constants';
import ConfirmAccountContext from '../../contexts/ConfirmAccountContext';
import CoBranding from '../CoBranding/CoBranding';
import PageLayout from '../../layout/PageLayout/PageLayout';

const ConfirmAccountPickOwner: FC = () => {
    const { language, coBranding } = useContext(GlobalContext);
    const { setFirstName, setLastName, setFirstNameIsValid, setLastNameIsValid, confirmingUser } =
        useContext(ConfirmAccountContext);
    const [addNewOwner, setAddNewOwner] = useState<boolean>(true);
    const history = useHistory();

    const handleCtaClick = (event) => {
        event.preventDefault();
        addNewOwner ? setFirstName('') : setFirstName(confirmingUser.firstName);
        setLastName(confirmingUser.lastName);
        setFirstNameIsValid(true);
        setLastNameIsValid(true);
        history.push(ERoutes.confirmAccountDetails);
    };

    return (
        <PageLayout>
            <Card>
                {(coBranding.logoUrl || coBranding.name) && (
                    <CoBranding logoUrl={coBranding.logoUrl} name={coBranding.name} />
                )}
                <header className={styles.header}>
                    <strong className={common.progressHeader}>{`${language.common.step} 1`}</strong>
                    <h1 className={common.pageHeader}>{language.confirmAccount.addOwner.title}</h1>
                    <p>{language.confirmAccount.addOwner.desc}</p>
                </header>
                <form>
                    <main>
                        <RadioButton
                            isActive={addNewOwner}
                            label={language.confirmAccount.addOwner.cta}
                            onChange={() => setAddNewOwner(true)}
                        />
                        <RadioButton
                            isActive={!addNewOwner}
                            label={confirmingUser.firstName}
                            onChange={() => setAddNewOwner(false)}
                        />
                        <section className={styles.formCta}>
                            <Button
                                variant="contained"
                                type="submit"
                                onClick={handleCtaClick}
                                className={common.buttonShim}
                                disabled={addNewOwner === null}
                                size="large"
                            >
                                {language.common.next}
                            </Button>
                        </section>
                    </main>
                </form>
            </Card>
        </PageLayout>
    );
};

export default ConfirmAccountPickOwner;
